/**
 * TtfHorizontalHeaderTable.ts class for EJ2-PDF
 */
var TtfHorizontalHeaderTable = /** @class */ (function () {
    function TtfHorizontalHeaderTable() {
    }
    return TtfHorizontalHeaderTable;
}());
export { TtfHorizontalHeaderTable };
